// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__AoISf","pintxo-tab__content":"Tab_pintxo-tab__content__7hNJC","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__rfyug"};